import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import LoadingSpinner from './common/LoadingSpinner';

export default function RootRedirect() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <LoadingSpinner />;
  return <Navigate to={isAuthenticated ? '/workspace' : '/login'} replace />;
}
